import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

// GET s1/api/organizations -> { organizations: [{ id, name, description, created_date, update_date }] }
// Those five fields are the whole record. No risk score, no finding counts, no owner.
export function useOrganizations() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    try {
      const data = await api.get("s1/api/organizations");
      setOrganizations(data?.organizations || []);
      setError("");
    } catch (e) {
      setError(e.message || "Could not load organizations.");
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, []);

  useEffect(() => { load(false); }, [load]);

  const create = useCallback(async (fields) => {
    const data = await api.post("s1/api/create_organization", fields);
    if (data?.organization) setOrganizations((prev) => [...prev, data.organization]);
    else await load(true);
    return data;
  }, [load]);

  return { organizations, loading, refreshing, error, reload: () => load(true), create };
}
